import React from "react";
import LegendItemColor from "./LegendItemColor";

const LegendContentColor = () => {
    return (
        <>
            <LegendItemColor title="Horas Letivas" color="#D2DCFF" />

            <LegendItemColor title="Horas Não Letivas" color="#FFD1DC" />

            <LegendItemColor title="Hora Letiva RE" color="#DABCFF" />

            <LegendItemColor title="Antecipação" color="#057C84" />

            <LegendItemColor title="Reposição" color="#FF7D04" />

            <LegendItemColor title="Substituição" color="#3907FF" />

            <LegendItemColor title="Atividade Avulsa" color="#FEECAA" />

            <LegendItemColor
                title="Recreio Estudantes/ Interjornada"
                color="#D5FFB1"
            />
        </>
    );
};

export default LegendContentColor;
